module.exports = __webpack_public_path__ + "img/Black_joker.svg.65cc9dc5.png";